import { put, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';

function* fetchClients() {
    const response = yield axios.get(`/api/client`);
    yield put({ type: 'SET_CLIENTS', payload: response.data });
}

function* fetchSingleClient(action) {
    try {
        const response = yield axios.get(`/api/client/${action.payload.id}`);
        yield put({ type: 'SET_CLIENT', payload: response.data });
    } catch (error) {
        console.log(`Error fetching request with id: ${action.payload}`, error);
    }
}

function* clientSaga() {
    yield takeLatest('FETCH_CLIENTS', fetchClients);
    yield takeLatest('FETCH_SINGLE_CLIENT', fetchSingleClient);
}

export default clientSaga;